/**
 * Cams API
 * Cams
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface SavingProductGroupContributionOutputDto { 
    id?: number;
    savingProductId?: number;
    savingProductCycleId?: number | null;
    cycleNumber?: number;
    userId?: number;
    fullName?: string | null;
    emailAddress?: string | null;
    amount?: number;
    status?: string | null;
    paymentTransactionId?: string | null;
    savingProductName?: string | null;
}

